import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "w100 pad20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "header_title fs20 fw600" }, "外部通知設定", -1)
const _hoisted_5 = { class: "fs14 mt20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomNotificationContent = _resolveComponent("CustomNotificationContent")!
  const _component_ZapierNotificationContent = _resolveComponent("ZapierNotificationContent")!
  const _component_HubspotNotificationContent = _resolveComponent("HubspotNotificationContent")!
  const _component_SalesforceNotificationContent = _resolveComponent("SalesforceNotificationContent")!
  const _component_GoogleSpreadSheetNotificationContent = _resolveComponent("GoogleSpreadSheetNotificationContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, "ユーザー（" + _toDisplayString(_ctx.rm.userInfo.email) + "）に紐づく調整ページに更新があった場合に通知します。", 1)
      ]),
      _hoisted_6,
      _hoisted_7,
      _createVNode(_component_CustomNotificationContent, {
        noti: _ctx.slackDic,
        availableEvents: _ctx.availableEvents,
        provider: `slack`,
        scope: `user`,
        onUpdateNotification: _ctx.updateNotification
      }, null, 8, ["noti", "availableEvents", "onUpdateNotification"]),
      _createVNode(_component_CustomNotificationContent, {
        noti: _ctx.teamsDic,
        availableEvents: _ctx.availableEvents,
        provider: `teams`,
        scope: `user`,
        onUpdateNotification: _ctx.updateNotification
      }, null, 8, ["noti", "availableEvents", "onUpdateNotification"]),
      _createVNode(_component_CustomNotificationContent, {
        noti: _ctx.webhookDic,
        availableEvents: _ctx.availableEvents,
        provider: `webhook`,
        scope: `user`,
        onUpdateNotification: _ctx.updateNotification
      }, null, 8, ["noti", "availableEvents", "onUpdateNotification"]),
      _createVNode(_component_ZapierNotificationContent, {
        noti: _ctx.zapierDic,
        scope: `user`,
        onUpdateNotification: _ctx.updateNotification
      }, null, 8, ["noti", "onUpdateNotification"]),
      _createVNode(_component_HubspotNotificationContent, {
        noti: _ctx.hubspotDic,
        scope: `user`,
        onUpdateNotification: _ctx.updateNotification
      }, null, 8, ["noti", "onUpdateNotification"]),
      _createVNode(_component_SalesforceNotificationContent, {
        noti: _ctx.salesforceDic,
        scope: `user`,
        onUpdateNotification: _ctx.updateNotification
      }, null, 8, ["noti", "onUpdateNotification"]),
      _createVNode(_component_GoogleSpreadSheetNotificationContent, {
        noti: _ctx.googleSpreadSheetDic,
        scope: `user`,
        onUpdateNotification: _ctx.updateNotification
      }, null, 8, ["noti", "onUpdateNotification"])
    ])
  ]))
}